import React, { FC } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { accessMainScore, MainScores } from 'app/lib/betting/accessMatchDetails';
import type { RecordOfMatchEntity } from 'app/lib/betting/betting-entities';
import { SportId, TeamId } from 'app/lib/betting/constants';
import { getPeriodsBySport } from 'app/lib/periods';

import { matches } from '../../selectors/entities';

import styles from './MatchTile.module.scss';

// ---

type StoreProps = {
  score: MainScores;
  sportId?: SportId;
  periods?: RecordOfMatchEntity['periods'];
  scores?: RecordOfMatchEntity['scores'];
};

type MatchDetailsProps = {
  matchId: number;
};

const MatchDetails: FC<MatchDetailsProps & StoreProps> = ({
  sportId,
  periods,
  scores,
  score,
}) => {
  const periodValue = getPeriodsBySport(periods, sportId, scores);
  const hasScore =
    typeof score?.get(TeamId.FIRST) === 'number'
    || typeof score?.get(TeamId.SECOND) === 'number';
  return (
    <div className={styles.matchDetails}>
      <p className={styles.matchText}>Сейчас идёт</p>

      <div className={styles.matchScores}>
        {periodValue && (
          <div className={styles.matchPeriod}>
            {periodValue}
            {hasScore && ','}
          </div>
        )}

        {hasScore && (
          <>
            <p className={styles.firstTeamScore}>{score?.get(TeamId.FIRST) ?? '--'}</p>
            <span>{' : '}</span>
            <p>{score?.get(TeamId.SECOND) ?? '--'}</p>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: ReduxState, { matchId }: MatchDetailsProps): StoreProps => {
  const match = matches(state).get(matchId);

  return {
    periods: match?.periods,
    scores: match?.scores,
    sportId: match?.sportId,
    score: accessMainScore(match),
  };
};

export default connect(mapStateToProps)(MatchDetails);
